import { combineReducers } from "redux";
import AUTH from "./authReducer";
import DASHBOARD_REDUCER from "./dashboardReducer";
import SUBSCRIPTION_REDUCER from "./subscriptionReducer";
import ORGANIZATION_ROLES_REDUCER from "./organizationRolesReducer";
import PAYMENT_SETUP_REDUCER from "./paymentSetupReducer";

export default combineReducers({
  auth: AUTH,
  dashboard: DASHBOARD_REDUCER,
  subscription: SUBSCRIPTION_REDUCER,
  organizationRoles: ORGANIZATION_ROLES_REDUCER,
  paymentSetup: PAYMENT_SETUP_REDUCER,
});
